// Controllers are registered by hand — the manifest generator is not wired up, so a
// new controller that is not added here silently never connects.
import { application } from "./application"

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import ExamViewController from "./exam_view_controller"
application.register("exam-view", ExamViewController)

import AnswerSheetController from "./answer_sheet_controller"
application.register("answer-sheet", AnswerSheetController)

import TopicPickerController from "./topic_picker_controller"
application.register("topic-picker", TopicPickerController)

import TimeZoneController from "./time_zone_controller"
application.register("time-zone", TimeZoneController)

import StreakHeartController from "./streak_heart_controller"
application.register("streak-heart", StreakHeartController)

import LandingCaseController from "./landing_case_controller"
application.register("landing-case", LandingCaseController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import PushSubscriptionController from "./push_subscription_controller"
application.register("push-subscription", PushSubscriptionController)

import EmailSuggestionController from "./email_suggestion_controller"
application.register("email-suggestion", EmailSuggestionController)

import PaceClockController from "./pace_clock_controller"
application.register("pace-clock", PaceClockController)

import FigureDiagramController from "./figure_diagram_controller"
application.register("figure-diagram", FigureDiagramController)

import FigureWalkController from "./figure_walk_controller"
application.register("figure-walk", FigureWalkController)

import UsernameSuggestionController from "./username_suggestion_controller"
application.register("username-suggestion", UsernameSuggestionController)

import ExplanationController from "./explanation_controller"
application.register("explanation", ExplanationController)
import AdminFiltersController from "./admin_filters_controller"
application.register("admin-filters", AdminFiltersController)

import AdminNavigationController from "./admin_navigation_controller"
application.register("admin-navigation", AdminNavigationController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)
